import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

import store from '../store/store';

export default {
    install(Vue) {
        // use a new Vue instance as the interface for Vue components to receive/send SignalR events
        // this way every component can listen to events or send new events using this.$questionHub
        const eventsHub = new Vue();
        Vue.prototype.$eventsHub = eventsHub

        // Provide methods to connect/disconnect from the SignalR hub
        let connection = null;
        let startedPromise = null;
        let manuallyClosed = false;

        const hubUrl = `${store.getters.baseUrl}/events-hub`;
        Vue.prototype.startEventsSignalR = (jwtToken) => {
            connection = new HubConnectionBuilder()
                .withUrl(hubUrl, jwtToken ? { accessTokenFactory: () => jwtToken } : null)
                .configureLogging(LogLevel.Error)
                .build()

            // Forward hub events through the event, so we can listen for them in the Vue components
            connection.on('EventAdded', (id, eventName, eventCode) => {
                eventsHub.$emit('event-addded', { id, eventName, eventCode })
            })

            connection.on('EventDeleted', (id, eventName, eventCode) => {
                eventsHub.$emit('event-deleted', { id, eventName, eventCode })
            })

            connection.on('EventUpdated', (id, eventName, eventCode) => {
                eventsHub.$emit('event-updated', { id, eventName, eventCode })
            })

            connection.on('TempRankingConfirmed', (eventName, personName, personNameEn) => {
                eventsHub.$emit('tempranking-confirmed', { eventName, personName, personNameEn })
            })

            connection.on('TempRankingRejected', (eventName, personName, personNameEn) => {
                eventsHub.$emit('tempranking-rejected', { eventName, personName, personNameEn })
            })

            connection.on('SubscribedForEventNotification', (eventName, eventCode, username) => {
                eventsHub.$emit('subscribe-event-notification', { eventName, eventCode, username })
            })

            connection.on('UnsubscribedForEventNotification', (eventName, eventCode, username) => {
                eventsHub.$emit('unsubscribe-event-notification', { eventName, eventCode, username })
            })

            connection.on('ActionLogCreate', (userId) => {
                eventsHub.$emit('action-log-create', { userId })
            })

            connection.on('AppSigningSettingsUpdate', () => {
                eventsHub.$emit('app-signing-settings-update')
            })

            // You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
            // Docs recommend listening onclose and handling it there.
            // This is the simplest of the strategies
            function start() {
                startedPromise = connection.start()
                    .then(e => {
                        console.log('event-hub started');
                    })
                    .catch(err => {
                        console.error('Failed to connect with hub', err)
                        return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 30000))
                    })
                return startedPromise
            }
            connection.onclose(() => {
                if (!manuallyClosed) {
                    start()
                }
            })

            // Start everything
            manuallyClosed = false;
            start();
        }
        Vue.prototype.stopEventsSignalR = () => {
            if (!startedPromise) {
                return;
            }

            manuallyClosed = true
            return startedPromise
                .then(() => connection.stop())
                .then(() => { startedPromise = null })
        }

        // Provide methods for components to send messages back to server
        // Make sure no invocation happens until the connection is established

        // eventsHub.sendMessage = (message, gameUid) => {
        //  if (!startedPromise) return

        //  return startedPromise
        //    .then(() => connection.invoke('SendLiveChatMessage', message, gameUid))
        //    .catch(console.error)
        // }
    }
}
